import { render, staticRenderFns } from "./SampleAskManage.vue?vue&type=template&id=bf1e40c2&"
import script from "./SampleAskManage.vue?vue&type=script&lang=js&"
export * from "./SampleAskManage.vue?vue&type=script&lang=js&"
import style0 from "./SampleAskManage.vue?vue&type=style&index=0&id=bf1e40c2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf1e40c2')) {
      api.createRecord('bf1e40c2', component.options)
    } else {
      api.reload('bf1e40c2', component.options)
    }
    module.hot.accept("./SampleAskManage.vue?vue&type=template&id=bf1e40c2&", function () {
      api.rerender('bf1e40c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/asks/sample-ask-manage/SampleAskManage.vue"
export default component.exports